import React, {useState, useEffect} from "react";

type DelayedFallbackProps = {
    delay?: number;
    children: React.ReactNode;
};

const DelayedFallback: React.FC<DelayedFallbackProps> = ({delay = 200, children}) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setShow(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    if (!show) {
        return null;
    }

    return <>{children}</>;
};

export default DelayedFallback;
